import { useState, useEffect } from 'react';

export default function Reviews() {
    const [currentReview, setCurrentReview] = useState(0);
    const totalReviews = 8;

    // Dynamic image imports
    function importAll(requireContext) {
        return requireContext.keys().map((key) => ({ key, src: requireContext(key) }));
    }

    const reviewImagesContext = require.context('../assets/cover/reviews', false, /\.(webp|png|jpe?g|svg)$/);
    const reviewImages = importAll(reviewImagesContext)
        .sort((a, b) => a.key.localeCompare(b.key))
        .map((x) => x.src);

    // Review data
    const reviews = [
        {
            quote: "Muy buen IPTV y soporte técnico excelente.",
            name: "Carlos García",
            location: "Madrid",
            image: reviewImages[0] || "./assets/cover/reviews/francereview01.webp"
        },
        {
            quote: "Servicio excelente, ¡calidad HD perfecta!",
            name: "María López",
            location: "Barcelona",
            image: reviewImages[1] || "./assets/cover/reviews/francereview02.webp"
        },
        {
            quote: "Instalación rápida, interfaz intuitiva.",
            name: "Pedro Martínez",
            location: "Valencia",
            image: reviewImages[2] || "./assets/cover/reviews/francereview03.webp"
        },
        {
            quote: "Soporte al cliente receptivo, ¡muy satisfecho!",
            name: "Sofía Rodríguez",
            location: "Sevilla",
            image: reviewImages[3] || "./assets/cover/reviews/francereview04.webp"
        },
        {
            quote: "Calidad excepcional, ¡lo recomiendo!",
            name: "Antonio Sánchez",
            location: "Málaga",
            image: reviewImages[4] || "./assets/cover/reviews/francereview06.webp"
        },
        {
            quote: "¡Perfecto para toda la familia!",
            name: "Laura Fernández",
            location: "Bilbao",
            image: reviewImages[5] || "./assets/cover/reviews/francereview07.webp"
        },
        {
            quote: "Interfaz moderna e intuitiva.",
            name: "Tomás González",
            location: "Zaragoza",
            image: reviewImages[6] || "./assets/cover/reviews/francereview09.webp"
        },
        {
            quote: "¡Excelente relación calidad-precio!",
            name: "Natalia Ruiz",
            location: "Murcia",
            image: reviewImages[7] || "./assets/cover/reviews/francereview10.webp"
        }
    ];

    // Auto-play functionality
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentReview((prev) => (prev + 1) % totalReviews);
        }, 3000);

        return () => clearInterval(interval);
    }, [totalReviews]);

    const goToReview = (index) => {
        setCurrentReview(index);
    };

    const StarIcon = () => (
        <svg className="w-5 h-5 text-orange-400" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
    );

    return (
        <section className="py-8">
            <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
                    <div>
                        <div className="flex items-center justify-center sm:justify-start gap-1 mb-3">
                            {[...Array(5)].map((_, i) => (
                                <StarIcon key={i} />
                            ))}
                        </div>

                        <p className="text-gray-600 text-sm mb-6 text-center sm:text-start">4,5 de 5 basado en +1204 opiniones</p>

                        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-center sm:text-start font-black leading-tight text-orange-500 mb-4">
                            Opiniones de nuestros queridos clientes.
                        </h2>

                        <p className="text-gray-600 text-base sm:text-lg max-w-xl text-center sm:text-start">
                            Descubra lo que nuestros clientes dicen sobre la calidad de nuestros servicios y nuestra asistencia.
                        </p>
                    </div>

                    <div className="reviews-carousel contact-pricing rounded-2xl shadow-xl p-6 md:p-8 border border-gray-100 relative">
                        <div className="reviews-track" style={{ transform: `translateX(-${currentReview * 100}%)` }}>
                            {reviews.map((review, index) => (
                                <div key={index} className="review-slide">
                                    <div className={`review-content ${index === currentReview ? 'active' : ''}`}>
                                        <div className="flex items-center gap-1 mb-4">
                                            {[...Array(5)].map((_, i) => (
                                                <StarIcon key={i} />
                                            ))}
                                        </div>

                                        <div className="mb-4 rounded-lg overflow-hidden border border-orange-200">
                                            <img src={review.image} alt="IPTV Interface Review" className="w-full h-auto" />
                                        </div>

                                        <blockquote className="text-orange-50 font-semibold text-lg mb-4">
                                            "{review.quote}"
                                        </blockquote>

                                        <div className="mb-4">
                                            <p className="text-orange-50 font-semibold">{review.name}</p>
                                            <p className="text-orange-100 text-sm">{review.location}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="review-nav-dots">
                            {reviews.map((_, index) => (
                                <div
                                    key={index}
                                    className={`review-dot ${index === currentReview ? 'active' : ''}`}
                                    onClick={() => goToReview(index)}
                                ></div>
                            ))}
                        </div>

                        <div className="absolute bottom-4 right-8 text-orange-200 text-9xl font-serif opacity-30">"</div>
                    </div>
                </div>
            </div>
        </section>
    );
}